module.exports = __webpack_public_path__ + "1584c73974078ff97a78f6f14032f86a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/2.jpg
 ** module id = 212
 ** module chunks = 0
 **/